<template>
  <div>
    <b-row>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.research_contact_date"
          label-for="research_contact_date"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            :titleText="$lang.research_contact_date_tooltip"
            slot="label"
            :label="$lang.research_contact_date"
            :rules="$v.research_contact_date.$params"
          />
          <date-picker
            v-model="$v.research_contact_date.$model"
            type="datetime"
            :state="
              $v.research_contact_date.$dirty
                ? !$v.research_contact_date.$error
                : null
            "
            inputReq="true"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="dddd jYYYY/jMM/jDD ساعت HH:mm"
            :max="new Date() | moment('YYYY/MM/DD HH:mm')"
            clearable
            :class="
              $v.research_contact_date.$dirty
                ? $v.research_contact_date.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>

          <b-form-invalid-feedback
            :style="{
              display: $v.research_contact_date.$error ? 'block' : 'none',
            }"
            id="gender_id-feedback"
          >
            {{ $lang.error_required | replace($lang.research_contact_date) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.research_contact_status"
          label-for="research_contact_status"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_contact_status"
            :rules="$v.research_contact_status_selected.$params"
          />
          <selectFind
            :options="research_contact_status_options"
            v-model="$v.research_contact_status_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.research_contact_status_selected.$dirty
                ? !$v.research_contact_status_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.research_contact_status_selected.$error
                ? 'block'
                : 'none',
            }"
            id="research_contact_status_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.research_contact_status) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.research_contact_description"
          label-for="research_contact_description"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_contact_description"
            :rules="$v.research_contact_description.$params"
          />
          <b-form-textarea
            type="text"
            v-model="$v.research_contact_description.$model"
            :autocomplete="$lang.research_contact_description"
            :rows="this.$config.form.textareaRows"
          >
          </b-form-textarea>
          <b-form-invalid-feedback id="year_birth-feedback">
            {{
              $lang.error_required | replace($lang.research_contact_description)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4">
        <b-form-group
          :label="$lang.research_visit_type"
          label-for="research_visit_type"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_visit_type"
            :rules="$v.research_visit_type_selected.$params"
          />
          <selectFind
            :options="research_visit_type_options"
            v-model="$v.research_visit_type_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.research_visit_type_selected.$dirty
                ? !$v.research_visit_type_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.research_visit_type_selected.$error
                ? 'block'
                : 'none',
            }"
            id="research_visit_type_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.research_visit_type) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4">
        <b-form-group
          :label="$lang.research_visit_location"
          label-for="research_visit_location"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_visit_location"
            :rules="$v.research_visit_location.$params"
          />
          <b-form-input
            id="research_visit_location"
            type="text"
            :autocomplete="$lang.research_visit_location"
            :state="
              $v.research_visit_location.$dirty
                ? !$v.research_visit_location.$error
                : null
            "
            v-model="$v.research_visit_location.$model"
          ></b-form-input>

          <b-form-invalid-feedback id="research_visit_location-feedback">
            {{ $lang.error_required | replace($lang.research_visit_location) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4">
        <b-form-group
          :label="$lang.research_visit_date"
          label-for="research_visit_date"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            :titleText="$lang.research_visit_date_tooltip"
            slot="label"
            :label="$lang.research_visit_date"
            :rules="$v.research_visit_date.$params"
          />
          <date-picker
            v-model="$v.research_visit_date.$model"
            type="datetime"
            :state="
              $v.research_visit_date.$dirty
                ? !$v.research_visit_date.$error
                : null
            "
            inputReq="true"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="dddd jYYYY/jMM/jDD ساعت HH:mm"
            clearable
            :class="
              $v.research_visit_date.$dirty
                ? $v.research_visit_date.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>

          <b-form-invalid-feedback
            :style="{
              display: $v.research_visit_date.$error ? 'block' : 'none',
            }"
            id="gender_id-feedback"
          >
            {{ $lang.error_required | replace($lang.research_visit_date) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.research_visit_description"
          label-for="research_visit_description"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_visit_description"
            :rules="$v.research_visit_description.$params"
          />
          <b-form-textarea
            type="text"
            v-model="$v.research_visit_description.$model"
            :autocomplete="$lang.research_visit_description"
            :rows="this.$config.form.textareaRows"
          ></b-form-textarea>
          <b-form-invalid-feedback id="year_birth-feedback">
            {{
              $lang.error_required | replace($lang.research_visit_description)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="text-right mt-3">
        <b-button
          type="reset"
          class="mr-2"
          variant="outline-danger"
          @click="closeModal"
        >
          <mdicon name="close" size="20" />
          {{ $lang.cancelButton }}
        </b-button>
        <b-button
          v-if="
            includes('admin', parentPermissions) ||
            includes('edit', parentPermissions)
          "
          variant="success"
          @click="submit"
        >
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { renderEumOptions } from "@/shared/utils";
import { pathOr, includes } from "ramda";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  validations: {
    research_contact_status_selected: {
      required,
    },
    research_visit_type_selected: {},

    research_visit_date: {},
    research_contact_date: {
      required,
    },
    research_contact_description: {},
    research_visit_description: {},
    research_visit_location: {},
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      research_visit_type_selected: null,
      research_contact_status_selected: null,
      research_contact_description: null,
      research_visit_description: null,
      research_visit_date: null,
      research_contact_date: null,
      research_visit_location: null,
    };
  },
  computed: {
    research_contact_status_options() {
      return renderEumOptions("research_contact_status");
    },
    research_visit_type_options() {
      return renderEumOptions("research_visit_type");
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        contact_at: this.research_contact_date,
        contact_status_id: pathOr(
          null,
          ["value"],
          this.research_contact_status_selected
        ),
        contact_description: this.research_contact_description,
        visit_type_id: pathOr(
          null,
          ["value"],
          this.research_visit_type_selected
        ),
        visit_at: this.research_visit_date,
        visit_description: this.research_visit_description,
        visit_location: this.research_visit_location,

        // research_relation_id: this.id,
      };
      this.$emit("submit", payload);
    },
    closeModal() {
      this.$emit("closeModal");
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.research_contact_date = pathOr(
          null,
          ["contact_at", "gregorian"],
          this.item
        );
        this.research_contact_description = pathOr(
          null,
          ["contact_description"],
          this.item
        );

        this.research_visit_date = pathOr(
          null,
          ["visit_at", "gregorian"],
          this.item
        );

        this.research_visit_location = pathOr(
          null,
          ["visit_location"],
          this.item
        );

        this.research_visit_description = pathOr(
          null,
          ["visit_description"],
          this.item
        );

        this.research_contact_status_selected =
          this.research_contact_status_options.find(
            (x) => x.value === pathOr(0, ["contact_status", "id"], this.item)
          );
        this.research_visit_type_selected =
          this.research_visit_type_options.find(
            (x) => x.value === pathOr(0, ["visit_type", "id"], this.item)
          );
      }
    },
  },
};
</script>
